import React from 'react';
import { ActionField } from 'components/fields';
import RefundField from './RefundField';
import CancelAchTransactionField from './CancelAchTransactionField';

const TransactionActionsField = (props) => {
  const { record, currencyCode, onRefund } = props;

  const isRefunded =
    record?.transactions &&
    record.transactions[0]?.details?.receiptDetails?.refundStatus === 'succeeded';

  const isCurrency =
    record?.transactions && record.transactions[0]?.amount?.currency === currencyCode;

  const hideCancelAction = !record?.details?.achAllocation || record.status !== 'PENDING';

  const hideRefundAction =
    record.type !== 'DEPOSIT' || record?.status !== 'CONFIRMED' || isRefunded || !isCurrency;

  if (hideRefundAction && hideCancelAction) {
    return null;
  }

  return (
    <ActionField>
      <RefundField onRefund={onRefund} record={record} hideAction={hideRefundAction} />
      <CancelAchTransactionField record={record} hideAction={hideCancelAction} />
    </ActionField>
  );
};

export default TransactionActionsField;
